import * as api from '../prospectsApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  FreezeProspect,
  IProspectApiResponse,
  prospectActionCreators,
  ProspectsActionKeys
  } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* freezeProspectSaga(action: FreezeProspect) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IEntityWithMessages<IProspectApiResponse> = yield call(api.FreezeProspect, action.payload);

  if (!response.error && response.value) {
    yield put(prospectActionCreators.updateProspectFulfilled(response.value));
  }

  if (response.messages.length > 0) {
    let title: string = `Please review the following messages:`;

    if (response.exception) {
      title = 'The server encountered the following error(s) trying to update this prospect.';
    }
    yield put(
      uiActionCreators.showMessageDialog({
        messages: response.messages,
        title
      })
    );
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchFreezeProspect() {
  yield takeEvery(ProspectsActionKeys.FREEZE_PROSPECT, freezeProspectSaga);
}
